import { LOCATION_SEARCH_SELECT_LOCATION_COMPLETE } from 'CoreComponents/locationSearch/events';

const SELECTOR = {
  headerLocationFilter: '.form-photographer-filter--header .location-search__input',
  headerGeoLocationFilter: '.form-photographer-filter--header__input-geolocation',
  locationFilter: '.location-search__input',
  locationFilterInputField: '.location-search-input',
  geoLocationFilter: '.form-photographer-filter__input-geolocation',
  distanceSlider: '.slider',
  minDistanceFilter: '.form-photographer-filter__input-distance-min',
  maxDistanceFilter: '.form-photographer-filter__input-distance-max'
};

class InstantBookingPhotographerFilterForm {
  constructor(elementRef) {
    // Initialise attributes
    this.elementRef = elementRef;
    this.locationFilter = this.elementRef.querySelector(SELECTOR['locationFilter']);
    this.geoLocationFilter = this.elementRef.querySelector(SELECTOR['geoLocationFilter']);
    this.locationFilterInputField = this.elementRef.querySelector(SELECTOR['locationFilterInputField']);
    this.headerLocationFilter = document.querySelector(SELECTOR['headerLocationFilter']);
    this.headerGeoLocationFilter = document.querySelector(SELECTOR['headerGeoLocationFilter']);
    this.distanceSliders = document.querySelectorAll(SELECTOR['distanceSlider']);
    this.minDistanceFilter = this.elementRef.querySelector(SELECTOR['minDistanceFilter']);
    this.maxDistanceFilter = this.elementRef.querySelector(SELECTOR['maxDistanceFilter']);

    this.changeHandler = this.changeHandler.bind(this);
    this.headerLocationChangeHandler = this.headerLocationChangeHandler.bind(this);
    this.distanceSliderChangeHandler = this.distanceSliderChangeHandler.bind(this);

    this._addEventListeners();
  }

  changeHandler() {
    this.elementRef.submit();
  }

  headerLocationChangeHandler() {
    this.locationFilterInputField.value = this.headerLocationFilter.value;
    this.geoLocationFilter.value = this.headerGeoLocationFilter.value;

    this.elementRef.submit();
  }

  distanceSliderChangeHandler(event) {
    let distanceRange = event.target.querySelector('.slider__container').noUiSlider.get();

    this.minDistanceFilter.value = distanceRange[0];
    this.maxDistanceFilter.value = distanceRange[1];

    this.elementRef.submit();
  }

  _addEventListeners() {
    this.locationFilter.addEventListener(LOCATION_SEARCH_SELECT_LOCATION_COMPLETE, this.changeHandler);
    this.headerLocationFilter.addEventListener(LOCATION_SEARCH_SELECT_LOCATION_COMPLETE, this.headerLocationChangeHandler);
    this.distanceSliders.forEach((distanceSlider) => {
      distanceSlider.addEventListener('change', this.distanceSliderChangeHandler);
    });
  }
}

export default InstantBookingPhotographerFilterForm;



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/instantBookingPhotographerFilterForm/index.js